import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const OpenTournament: React.FC = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;

  return (
    <Box
      sx={{
        maxWidth: 900,
        mx: 'auto',
        mt: 4,
        p: { xs: 2.5, sm: 3.5 },
        borderRadius: 3,
        background:
          mode === 'light'
            ? 'rgba(255,255,255,0.95)'
            : 'linear-gradient(135deg, rgba(13,71,161,0.25) 0%, rgba(21,101,192,0.18) 100%)',
        boxShadow:
          mode === 'light'
            ? '0 10px 30px rgba(25,118,210,0.18)'
            : '0 16px 40px rgba(0,0,0,0.7)',
        border:
          mode === 'light'
            ? '1px solid rgba(255,255,255,0.7)'
            : '1px solid rgba(99,170,255,0.35)',
        textAlign: 'center',
      }}
    >
      <Helmet>
        <title>Open Tournament - RaketerS</title>
      </Helmet>

      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{ fontWeight: 'bold' }}
      >
        Open Tournament
      </Typography>

      <Typography variant="body1" sx={{ mt: 1.5, opacity: 0.85 }}>
        Halaman Open Tournament akan segera hadir. Nantikan informasi turnamen terbuka RaketerS di sini.
      </Typography>
    </Box>
  );
};

export default OpenTournament;

